<template>
    <div class="e-histogram">
        <ve-histogram
            :data="chartData"
            :settings="chartSettings"
            :extend="extend"
            :legend-visible="false"
            :tooltip-visible="false"
            height="80px"
        />
    </div>
</template>

<script>
export default {
    props: {
        colors: {
            type: Array,
            default: () => [
                "rgba(254,106,172,1)", // 0% 处的颜色
                "rgba(254,106,172,0)", // 100% 处的颜色
            ],
        },
        rows: {
            type: Array,
            default: () => [1393, 3530, 2923, 1723, 3792, 4593],
        },
    },
    data() {
        this.chartSettings = {
            stack: { 'v': ['v1', 'v2'] }
        };
      this.extend = {
            color:this.colors,
            yAxis: {
                show: false,
            },
            xAxis: {
                show: false,
            },
            legend: {
                show: false,
            },
            symbol: 'none',
            grid: {
                height: "70px",
                width: "90px",
                right: 10,
                top: 0,
            },
        };
      return {
        chartData: {
          columns: ['l', 'v1', 'v2'],
          rows: this.rows
        }
      }
    },
};
</script>
<style lang="scss" scoped>
.e-histogram{
    height: 80px;
}
</style>
